<template>
    <div class="container" v-loading="loading">
        <div class="my-3">
            <b-card>
                <ValidationObserver ref="observer" v-slot="{ passes }">
                    <b-form id="form" @submit.stop.prevent="passes(onSubmit)">
                        <div class="row">
                            <div class="col-md-6 col-lg-4">
                                <!--<b-form-group>
                                    <label class="label-control" for="name">
                                        {{lang.label.prescription}}:
                                        <span class="text-danger">*</span>
                                    </label>
                                    <ValidationProvider
                                            name="prescription"
                                            rules="required"
                                            v-slot="validationContext"
                                    >
                                        <vue-bootstrap-typeahead
                                                id="prescription"
                                                ref="prescription"
                                                v-model="models.prescription"
                                                :data="prescriptionList"
                                                :minMatchingChars= 3
                                                :state="getValidationStatePrescription(validationContext)"
                                                :serializer="s => s.prescription"
                                                :placeholder="lang.label.placeholder.enterdescription"
                                        >
                                            <template slot="suggestion" slot-scope="{ data, htmlText }">
                                                <span v-html="htmlText"></span><br />
                                                <small v-html="data.mobile"></small>
                                            </template>
                                        </vue-bootstrap-typeahead>
&lt;!&ndash;                                        <span v-if="validationContext.errors[0] && !nameError" class="error">{{validationContext.errors[0]}}</span>&ndash;&gt;
                                        <b-form-invalid-feedback style="color: red;font-size: 12px;" v-if="validationContext.failedRules.required"> {{lang.label.validationMessages.prescriptionRequired}}</b-form-invalid-feedback>
&lt;!&ndash;                                        <span v-else-if="nameError" class="error">{{lang.label.nameError}}</span>&ndash;&gt;
                                    </ValidationProvider>
                                </b-form-group>-->
                                <b-form-group>
                                    <label class="label-control" for="name">
                                        {{lang.label.prescription}}:
                                        <span class="text-danger">*</span>
                                    </label>
                                    <ValidationProvider
                                        name="prescription"
                                        rules="required"
                                        v-slot="validationContext"
                                        >
                                        <b-form-textarea
                                            :state="getValidationStatePrescription(validationContext)"
                                            ref="prescription"
                                            type="text"
                                            :placeholder="lang.label.placeholder.enterdescription"
                                            rows="3"
                                            max-rows="3"
                                            @input="onChange"
                                            v-model="search"
                                            @keydown.down="onArrowDown"
                                            @keydown.up="onArrowUp"
                                            @keydown.enter="onEnter"
                                            @blur="prescriptionBlurred"
                                            ></b-form-textarea>
                                        <ul
                                            id="autocomplete-results"
                                            class="autocomplete-results"
                                            v-show="isOpen"
                                            v-if="results.length"
                                            >
                                            <li
                                                class="loading"
                                                v-if="isLoading"
                                                >
                                                Loading results...
                                            </li>
                                            <li
                                                v-else
                                                v-for="(result, i) in results"
                                                :key="i"
                                                @click="setResult(result)"
                                                class="autocomplete-result vbst-item list-group-item list-group-item-action"
                                                :class="{ 'is-active': i === arrowCounter }"
                                                >
                                                <div class="d-flex justify-content-between">
                                                    <span>{{ result.prescription }}</span>
                                                    <b-button @click="deletePrescription(result)" variant="link" class="p-0"><i class="fas fa-times fa-sm"></i></b-button>
                                                </div>
                                                <!-- <i class="fas fa-trash-alt fa-sm"></i> -->
                                        </li>
                                    </ul>
                                    <b-form-invalid-feedback style="color: red;font-size: 12px;" v-if="validationContext.failedRules.required"> {{lang.label.validationMessages.prescriptionRequired}}</b-form-invalid-feedback>
                                    <!--<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>-->
                                </ValidationProvider>
                            </b-form-group>
                        </div>
                        <div class="col-md-6 col-lg-4">
                            <b-form-group>
                                <label class="label-control" for="idNumber">{{lang.label.icdCode}}:</label>
                                <ValidationProvider name="ICD10 codes" v-slot="validationContext">
                                    <vue-bootstrap-typeahead
                                        id="icd10Code"
                                        ref="icd10Code"
                                        v-model="models.icdCode"
                                        :data="icdCodeList"
                                        :minMatchingChars= 1
                                        :state="getValidationState(validationContext)"
                                        :serializer="s => s.icdCode"
                                        :placeholder="lang.label.placeholder.enterIcdCode"
                                        >
                                        <template slot="suggestion" slot-scope="{ data, htmlText }">
                                            <span v-html="htmlText"></span><br />
                                        </template>
                                    </vue-bootstrap-typeahead>
                                </ValidationProvider>
                            </b-form-group>
                        </div>
                        <div class="col-md-6 col-lg-4">
                            <b-form-group>
                                <template v-if="signature">
                                    <label class="label-control" for="name">{{lang.label.signature}}:</label>
                                    <div class="text-center">
                                        <img :src="signature" height="92" width="133" alt="" />
                                    </div>
                                </template>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <h6 class="heading-title">{{lang.label.patientDetails}}</h6>
                            <span class="error" v-if="selectEmailOrMobilePatient">{{lang.label.selectOne}}</span>
                        </div>
                        <div class="col-md-4">
                            <b-form-group>
                                <label class="label-control" for="name">
                                    {{lang.label.patientName}}:
                                    <span class="text-danger">*</span>
                                </label>
                                <ValidationProvider
                                    name="Name of Patient"
                                    :rules="needToValidate ? {required:true} : ''"
                                    v-slot="validationContext"
                                    >
                                    <vue-bootstrap-typeahead
                                        id="patientName"
                                        ref="patientName"
                                        v-model="models.patientName"
                                        :data="patientList"
                                        :minMatchingChars= 1
                                        :state="getValidationState(validationContext)"
                                        :serializer="s => s.name"
                                        :placeholder="lang.label.placeholder.enterName"
                                        @hit="selectedPatient = $event"
                                        >
                                        <template slot="suggestion" slot-scope="{ data, htmlText }">
                                            <span v-html="htmlText"></span><br />
                                            <small v-html="data.mobile"></small>
                                        </template>
                                    </vue-bootstrap-typeahead>
                                    <span v-if="validationContext.errors[0] && !nameError" class="error">{{validationContext.errors[0]}}</span>
                                    <span v-else-if="nameError" class="error">{{lang.label.nameError}}</span>
                                </ValidationProvider>
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                            <b-form-group>
                                <label class="label-control" for="name">
                                    {{lang.label.mobileNumber}}:
                                </label>
                                <ValidationProvider
                                    name="mobile number"
                                    rules="digits:10"
                                    v-slot="validationContext"
                                    class="phone-input-group"
                                    >
                                    <b-form-input
                                        :state="getValidationState(validationContext)"
                                        v-model="models.mobileNumber"
                                        type="text"
                                        @keypress="isNumber(1,$event)"
                                        id="mobileError"
                                        :placeholder="lang.label.placeholder.enterMobileNumber"
                                        ></b-form-input>
                                    <span>{{lang.label.mobileExample}}</span><br />
                                    <span class="error" v-if="mobileRequired && !mobileError">{{lang.label.mobileRequired}}</span>
                                    <span class="error" v-if="mobileError && !mobileRequired">{{lang.label.mobileError}}</span>
                                    <b-form-invalid-feedback  v-if="validationContext.failedRules.digits">{{lang.label.validationMessages.mobilenumLength}}</b-form-invalid-feedback>
                                </ValidationProvider>
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                            <b-form-group>
                                <label class="label-control" for="email">{{lang.label.emailId}}:</label>
                                <ValidationProvider name="Email ID" rules="email" v-slot="validationContext">
                                    <b-form-input
                                        :state="getValidationState(validationContext)"
                                        v-model="models.emailId"
                                        type="text"
                                        :placeholder="lang.label.placeholder.enterEmailId"
                                        ></b-form-input>
                                    <span class="error" v-if="emailErrorPatient">{{lang.label.mobileErrorPharma}}</span>
                                    <b-form-invalid-feedback v-if="validationContext.failedRules.email">{{lang.label.validationMessages.emailFormat}}</b-form-invalid-feedback>
                                </ValidationProvider>
                            </b-form-group>
                        </div>
                        <template>
                            <div class="col-md-4">
                                <b-form-group>
                                    <label class="label-control" for="idNumber">{{lang.label.idNumber}}:</label>
                                    <ValidationProvider name="ID Number" v-slot="validationContext">
                                        <b-form-input
                                            :state="getValidationState(validationContext)"
                                            v-model="models.idNumber"
                                            type="text"
                                            :placeholder="lang.label.placeholder.enterIDNumber"
                                            ></b-form-input>
                                        <!--                    <span class="error" v-if="emailErrorPatient">{{lang.label.mobileError}}</span>-->
                                        <!--                    <b-form-invalid-feedback v-if="validationContext.failedRules.email">{{lang.label.validationMessages.emailFormat}}</b-form-invalid-feedback>-->
                                    </ValidationProvider>
                                </b-form-group>
                            </div>
                            <!--<div class="col-md-4">
                                <b-form-group>
                                    <label class="label-control" for="idNumber">{{lang.label.icdCode}}:</label>
                                    <ValidationProvider name="ICD10 codes" v-slot="validationContext">
                                        <vue-bootstrap-typeahead
                                                id="icd10Code"
                                                ref="icd10Code"
                                                v-model="models.icdCode"
                                                :data="icdCodeList"
                                                :minMatchingChars= 1
                                                :state="getValidationState(validationContext)"
                                                :serializer="s => s.icdCode"
                                                :placeholder="lang.label.placeholder.enterIcdCode"
                                        >
                                            <template slot="suggestion" slot-scope="{ data, htmlText }">
                                                <span v-html="htmlText"></span><br />
                                            </template>
                                        </vue-bootstrap-typeahead>
                                    </ValidationProvider>
                                </b-form-group>
                            </div>-->
                            <div class="col-md-4">
                                <b-form-group>
                                    <ValidationProvider name="patient Minor" v-slot="validationContext">
                                        <b-form-group>
                                            <b-form-checkbox-group
                                                v-model="models.patientMinor"
                                                :options="status"
                                                text-field="name"
                                                value-field="item"
                                                class="mt-4 pt-2"
                                                value="true"
                                                unchecked-value="false"
                                                ></b-form-checkbox-group>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group>
                                    <label class="label-control" for="parentName">{{lang.label.parentName}}:</label>
                                    <ValidationProvider name="Parent Name" v-slot="validationContext">
                                        <b-form-input
                                            :state="getValidationState(validationContext)"
                                            v-model="models.parentName"
                                            type="text"
                                            :placeholder="lang.label.placeholder.parentName"
                                            ></b-form-input>
                                    </ValidationProvider>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group>
                                    <label class="label-control" for="Parent/Guardian ID Number">{{lang.label.parentIDNumber}}:</label>
                                    <ValidationProvider name="Parent/Guardian ID Number" v-slot="validationContext">
                                        <b-form-input
                                            :state="getValidationState(validationContext)"
                                            v-model="models.parentIDNumber"
                                            type="text"
                                            :placeholder="lang.label.placeholder.parentIDNumber"
                                            ></b-form-input>
                                    </ValidationProvider>
                                </b-form-group>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <b-form-group>
                                    <label class="label-control" for="name">
                                        {{lang.label.medicineRequired}}:
                                    </label>
                                    <ValidationProvider
                                        name="prescription"
                                        v-slot="validationContext"
                                        >
                                        <b-form-textarea
                                            :state="getValidationState(validationContext)"
                                            v-model="models.medicineRequired"
                                            type="text"
                                            :placeholder="lang.label.placeholder.medicineRequired"
                                            rows="3"
                                            max-rows="3"
                                            disabled
                                            ></b-form-textarea>
                                        <b-form-invalid-feedback style="color: red;font-size: 12px;" v-if="validationContext.failedRules.required"> {{lang.label.validationMessages.medicineRequired}}</b-form-invalid-feedback>
                                    </ValidationProvider>
                                </b-form-group>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <b-form-group>
                                    <label class="label-control" for="name">
                                        {{lang.label.specialInstructions}}:
                                    </label>
                                    <ValidationProvider
                                        name="prescription"
                                        v-slot="validationContext"
                                        >
                                        <b-form-textarea
                                            :state="getValidationState(validationContext)"
                                            v-model="models.specialInstructions"
                                            type="text"
                                            :placeholder="lang.label.placeholder.medicineRequired"
                                            rows="3"
                                            max-rows="3"
                                            ></b-form-textarea>
                                        <b-form-invalid-feedback style="color: red;font-size: 12px;" v-if="validationContext.failedRules.required"> {{lang.label.validationMessages.medicineRequired}}</b-form-invalid-feedback>
                                    </ValidationProvider>
                                </b-form-group>
                            </div>
                        </template>
                        <div class="col-md-4">
                            <b-form-group>
                                <label class="label-control" for="dob">{{lang.label.dob}}:</label>
                                <el-date-picker v-model="models.dob" format="dd/MM/yyyy" :picker-options="datePickerOptions" type="date" :placeholder="lang.label.placeholder.date"></el-date-picker>
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                            <div class="row">
                                <div class="col-md-6 col-12">
                                    <b-form-group>
                                        <label class="label-control" for="gender">{{lang.label.gender}}:</label>
                                        <el-select
                                            v-model="models.gender"
                                            :placeholder="lang.label.placeholder.selectGender"
                                            >
                                            <el-option v-for="item in gender" :key="item.value" :value="item.value"></el-option>
                                        </el-select>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6 col-12">
                                    <b-form-group>
                                        <label class="label-control" for="blood group">{{lang.label.bloodGroup}}:</label>
                                        <el-select
                                            v-model="models.bloodGroup"
                                            :placeholder="lang.label.placeholder.selectBloodGroup"
                                            >
                                            <el-option v-for="item in bloodGroup" :key="item.value" :value="item.value"></el-option>
                                        </el-select>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <b-form-group>
                                <label class="label-control" for="blood group">{{lang.label.address}}:</label>
                                <b-form-textarea
                                    style="height: 40px"
                                    v-model="models.address"
                                    :placeholder="lang.label.placeholder.enterAddress"
                                    rows="1"
                                    max-rows="1"
                                    ></b-form-textarea>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <h6 class="heading-title">{{lang.label.pharmacistDetails}}</h6>
                        </div>
                        <div class="col-md-4">
                            <b-form-group>
                                <label class="label-control" for="name">
                                    {{lang.label.pharmacistName}}:
                                </label>
                                <ValidationProvider
                                    name="name of patient"
                                    v-slot="validationContext"
                                    >
                                    <vue-bootstrap-typeahead
                                        id="pharmacistName"
                                        ref="pharmacistName"
                                        v-model="modelsPharmacist.name"
                                        :data="pharmacistList"
                                        :minMatchingChars= 1
                                        :state="getValidationState(validationContext)"
                                        :serializer="s => s.name"
                                        :placeholder="lang.label.placeholder.enterName"
                                        @hit="selectedPharmacist = $event"
                                        >
                                        <template slot="suggestion" slot-scope="{ data, htmlText }">
                                            <span v-html="htmlText"></span><small v-if="data.location" v-html="' -'+data.location"></small><br />
                                            <small v-html="data.mobile"></small>
                                        </template>
                                    </vue-bootstrap-typeahead>
                                    <span v-if="pharmaNameError" class="error" >{{lang.label.pharmaNameError}}</span>
                                    <b-form-invalid-feedback v-if="!pharmaNameError">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </ValidationProvider>
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                            <b-form-group>
                                <label class="label-control" for="name">
                                    {{lang.label.mobileNumber}}:
                                </label>
                                <ValidationProvider
                                    name="mobile number"
                                    rules="digits:10"
                                    v-slot="validationContext"
                                    class="phone-input-group"
                                    >
                                    <b-form-input
                                        v-model="modelsPharmacist.number"
                                        @keypress="isNumber(2,$event)"
                                        :state="getValidationState(validationContext)"
                                        type="text"
                                        id="mobileErrorPharma"
                                        :placeholder="lang.label.placeholder.enterMobileNumber"
                                        ></b-form-input>
                                    <span>{{lang.label.mobileExample}}</span><br />
                                    <span v-if="pharmaMobileError && !mobileErrorPharma" class="error" >{{lang.label.mobileRequired}}</span>
                                    <span class="error" v-if="mobileErrorPharma && !pharmaMobileError">{{lang.label.mobileErrorPharma}}</span>
                                    <!--<b-form-invalid-feedback v-if="!mobileErrorPharma">{{ validationContext.errors[0] }}</b-form-invalid-feedback>-->
                                    <b-form-invalid-feedback  v-if="validationContext.failedRules.digits && !mobileErrorPharma && !pharmaMobileError">{{lang.label.validationMessages.mobilenumLengthPharma}}</b-form-invalid-feedback>
                                </ValidationProvider>
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                            <b-form-group>
                                <label class="label-control" for="email">{{lang.label.emailId}}:</label>
                                <ValidationProvider name="Email ID" rules="email" v-slot="validationContext">
                                    <b-form-input
                                        v-model="modelsPharmacist.emailId"
                                        type="text"
                                        :state="getValidationState(validationContext)"
                                        :placeholder="lang.label.placeholder.enterEmailId"
                                        ></b-form-input>
                                    <!--<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>-->
                                    <b-form-invalid-feedback v-if="validationContext.failedRules.email">{{lang.label.validationMessages.emailFormatPharma}}</b-form-invalid-feedback>
                                    <span v-if="emailError" class="error" >{{lang.label.mobileError}}</span>
                                </ValidationProvider>
                            </b-form-group>
                        </div>
                        <div class="col-12" style="margin-top: -15px;margin-bottom: 10px;"><span class="error" v-if="selectEmailOrMobile">{{lang.label.selectOnePharma}}</span></div>
                    </div>
                    <div class="row justify-content-between">
                        <div class="col-md-4">
                            <b-form-group>
                                <ValidationProvider name="Tariff" rules="required"  v-slot="validationContext">
                                    <div class="row">
                                        <label class="label-control md-text col-3 col-md-4 col-lg-3 mt-1 pt-1 secondary-text" for="tariff">{{lang.label.tariff}}:</label>
                                        <div class="col-9 col-md-8 col-lg-9">
                                            <b-input-group prepend="R">
                                                <b-form-input
                                                    v-model="tariff"
                                                    @keypress="isNumber(3,$event)"
                                                    type="text"
                                                    :state="getValidationState(validationContext)"
                                                    :placeholder="lang.label.placeholder.enterTariff"
                                                    ></b-form-input>
                                            </b-input-group>
                                        </div>
                                    </div>
                                    <span v-if="zeroValue && !validationContext.errors[0]" class="error">{{lang.label.tariffZero}}</span>
                                    <span v-if="validationContext.failedRules.required" class="error">{{lang.label.validationMessages.tariffRequired}}</span>
                                </ValidationProvider>
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                            <b-form-group class="mb-0 btn-mt">
                                <b-btn
                                    type="submit"
                                    variant="primary"
                                    class="w-100"
                                    @click="createScript"
                                    >{{lang.label.buttons.eCreateScript}}</b-btn>
                            </b-form-group>
                        </div>
                    </div>
                </b-form>
            </ValidationObserver>
        </b-card>
    </div>
    <b-modal id="modal-center" ref="share_modal" centered title="Share" hide-footer>
        <div class="share-buttons">
            <input  id="input-url" :value="sharedUrl" style="opacity: 0;position: absolute;z-index: -1">
            <b-btn variant="primary" class="w-100"><a style="color:#FFF" target="_blank" :href="sharedUrlWithDetails" @click="sendEmail">{{lang.label.modal.shareEScript}}</a></b-btn>
            <b-btn variant="primary" class="w-100"><a style="color:#FFF" href="javascript:void(0)" @click="openSmsModal">{{lang.label.modal.shareScriptSms}}</a></b-btn>
            <b-btn variant="primary" class="w-100 btn-copy"
                   v-clipboard:copy= sharedUrl
                   v-clipboard:success="onCopy"
                   v-clipboard:error="onError"
                   @click="copyToClipBoard1"
                   >{{lang.label.modal.copyEScript}}</b-btn>
        </div>
    </b-modal>
    <b-modal
        id="modal-center1"
        ref="send_sms"
        centered
        :title="lang.label.modal.sendSmsTitle"
        hide-footer
        >
        <ValidationObserver ref="observer1" v-slot="{ passes }">
            <b-form @submit.stop.prevent="passes(sendSms)">
                <b-form-group>
                    <div class="row">
                        <div class="col-12 col-md-12">
                            <label class="label-control" for="name">
                                {{lang.label.mobileNumber}}:
                                <span class="text-danger">*</span>
                            </label>
                        </div>
                        <div class="col-12 col-md-12">
                            <ValidationProvider
                                name="mobile number"
                                :rules="{required:true,digits:10,regex:/^0[0-9].*$/}"
                                v-slot="validationContext"
                                >
                                <b-form-input
                                    :state="getValidationState(validationContext)"
                                    v-model="smsNumber"
                                    ref="prescription"
                                    type="text"
                                    :placeholder="lang.label.placeholder.enterMobileNumber"
                                    ></b-form-input>
                                <b-form-invalid-feedback style="color: red;font-size: 12px;" v-if="validationContext.failedRules.required"> {{lang.label.validationMessages.mobileNumberRequired}}</b-form-invalid-feedback>
                                <b-form-invalid-feedback style="color: red;font-size: 12px;" v-if="validationContext.failedRules.digits"> {{lang.label.validationMessages.mobilenumLength}}</b-form-invalid-feedback>
                                <b-form-invalid-feedback style="color: red;font-size: 12px;" v-if="validationContext.failedRules.regex"> {{lang.label.validationMessages.startsWithZero}}</b-form-invalid-feedback>
                                <!--<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>-->
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-12 col-md-12">
                            <label class="label-control" for="name">
                                {{lang.label.smsContent}}:
                                <span class="text-danger">*</span>
                            </label>
                        </div>
                        <div class="col-12 col-md-12">
                            <ValidationProvider
                                name="sms content"
                                rules="required"
                                v-slot="validationContext"
                                >
                                <b-form-textarea
                                    :state="getValidationState(validationContext)"
                                    v-model="smsContent"
                                    ref="prescription"
                                    type="text"
                                    :placeholder="lang.label.smsContent"
                                    rows="3"
                                    max-rows="3"
                                    disabled
                                    ></b-form-textarea>
                                <b-form-invalid-feedback style="color: red;font-size: 12px;" v-if="validationContext.failedRules.required"> {{lang.label.validationMessages.prescriptionRequired}}</b-form-invalid-feedback>
                                <!--<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>-->
                            </ValidationProvider>
                        </div>
                    </div>
                </b-form-group>
                <div class="mt-3">
                    <b-btn type="submit" variant="primary" class="w-100">{{lang.label.buttons.send}}</b-btn>
                </div>
            </b-form>
        </ValidationObserver>
    </b-modal>
    <b-modal
        id="modal-center2"
        ref="send_note"
        centered
        :title="lang.label.sendNoteToNurse"
        hide-footer
        >
        <ValidationObserver ref="observer" v-slot="{ passes }">
            <b-form @submit.stop.prevent="passes(sendNote)">
                <b-form-group>
                    <div class="row">
                        <div class="col-12 col-md-12">
                            <label class="label-control" for="name">
                                {{lang.label.note}}:
                                <span class="text-danger">*</span>
                            </label>
                        </div>
                        <div class="col-12 col-md-12">
                            <ValidationProvider
                                name="reason"
                                rules="required"
                                v-slot="validationContext"
                                >
                                <b-form-textarea
                                    :state="getValidationState(validationContext)"
                                    v-model="note"
                                    ref="prescription"
                                    type="text"
                                    :placeholder="lang.label.enterNote"
                                    rows="3"
                                    max-rows="3"
                                    ></b-form-textarea>
                                <b-form-invalid-feedback style="color: red;font-size: 12px;" v-if="validationContext.failedRules.required"> {{lang.label.noteRequired}}</b-form-invalid-feedback>
                                <!--<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>-->
                            </ValidationProvider>
                        </div>
                    </div>
                </b-form-group>
                <div class="mt-3">
                    <b-btn type="submit" :disabled="onSend" variant="primary" class="w-100">{{lang.label.buttons.submit}}</b-btn>
                </div>
            </b-form>
        </ValidationObserver>
    </b-modal>
</div>
</template>

<script>
    import jsondata from "../assets/json/data.json";
    import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
    import {mapGetters} from "vuex";
    import moment from 'moment';
    import {patientInfo} from "../store/getters";
    export default {
        components: {VueBootstrapTypeahead},
        computed: {
            ...mapGetters({
                    login: "login",
                    loading: "loading",
                    patientInfo: "patientInfo",
                    fromGroupRequests: "fromGroupRequests",
            }),
            emailId() {
                return this.modelsPharmacist.emailId;
            },
            emailIdPatient() {
                return this.models.emailId;
            },
            name() {
                return  this.modelsPharmacist.name;
            },
            number() {
                return this.modelsPharmacist.number;
            },
            mobileNumber() {
                return this.models.mobileNumber;
            },
            patientName() {
                return this.models.patientName;
            },
        },
        watch: {
            tariff(val) {
                if (val < 0) {
                    this.tariff = '';
                }
            },
            name(val) {
                if (this.flagForNames) {
                    if (val) {
                        this.pharmaNameError = false;
                    }
                    if (this.modelsPharmacist.emailId || this.modelsPharmacist.number || !val) {
                        this.emailError = false;
                        this.pharmaMobileError = false;
                    }
                }
                this.flagForNames = true;
            },
            emailIdPatient(val) {
                if (val) {
                    this.emailError = false;
                    this.selectEmailOrMobilePatient = false;
                }
                if ((this.models.patientName || this.models.mobileNumber) || !val) {
                    this.nameError = false;
                    this.mobileError = false;
                } else {
                    if (!this.$refs.patientName.inputValue) {
                        this.nameError = true;
                    }
                }
            },
            emailId(val) {
                if (val) {
                    this.emailError = false;
                    this.selectEmailOrMobile = false;
                }
                if ((this.modelsPharmacist.name || this.modelsPharmacist.number) || !val) {
                    this.pharmaNameError = false;
                    this.pharmaMobileError = false;
                } else {
                    this.pharmaNameError = true;
                }
            },
            number(val) {
                if (val) {
                    this.pharmaMobileError = false;
                    this.selectEmailOrMobile = false;
                }
                if (this.modelsPharmacist.name || this.modelsPharmacist.emailId || !val) {
                    this.pharmaNameError = false;
                    this.emailError = false;
                } else {
                    this.pharmaNameError = true;
                }
                if (val && val.slice(0, 1) != 0) {
                    this.mobileErrorPharma = true;
                } else {
                    this.mobileErrorPharma = false;
                }
            },
            patientName(val) {
                if (this.flagForNames) {
                    if (val) {
                        this.nameError = false;
                    } else {
                        if (!this.newBeginning) {
                            this.nameError = true;
                        }
                        this.newBeginning = false;
                    }
                }
                this.flagForNames = true;
            },
            mobileNumber(val) {
                if (val) {
                    this.mobileRequired = false;
                    this.selectEmailOrMobilePatient = false;
                }
                if (val.slice(0, 1) != 0) {
                    this.mobileError = true;
                } else {
                    this.mobileError = false;
                }
            },
            fileList: function (val) {
            },
            selectedPatient: function (val) {
                if (val) {
                    this.selectedDetails = this.patientDetails.filter(c => {
                        return c.id == val.id;
                    });
                    if (this.selectedDetails[0].isMinor) {
                        this.models.patientMinor.push(this.status[0].item);
                    } else {
                        this.models.patientMinor = [];
                    }
                    this.models.name = this.selectedDetails[0].name;
                    this.models.parentName = this.selectedDetails[0].parentName;
                    this.models.parentIDNumber = this.selectedDetails[0].idNumberParent;
                    this.models.medicineRequired = this.selectedDetails[0].medicine;
                    this.models.idNumber = this.selectedDetails[0].idNumber;
                    this.models.specialInstructions = this.selectedDetails[0].specialInstructions;
                    this.models.address = this.selectedDetails[0].address;
                    this.models.bloodGroup = this.selectedDetails[0].bloodGroup;
                    this.models.dob = this.selectedDetails[0].dob;
                    this.models.emailId = this.selectedDetails[0].email;
                    let gender = '';
                    gender = this.selectedDetails[0].gender;
                    if (gender) {
                        this.models.gender = gender == 1 ? "Male" : (gender == 2 ? "Female" : "Other");
                    } else {
                        this.models.gender = '';
                    }
                    this.models.mobileNumber = this.selectedDetails[0].mobile;
                    this.tariff = this.selectedDetails[0].tariff;
                }
            },
            selectedPharmacist: function (val) {
                if (val) {
                    this.selectedDetailsPharmacist = this.pharmacistDetails.filter(c => {
                        return c.id == val.id;
                    });
                    console.log(this.selectedDetailsPharmacist[0].pharmacistId);
                    this.modelsPharmacist.emailId = this.selectedDetailsPharmacist[0].email;
                    this.modelsPharmacist.number = this.selectedDetailsPharmacist[0].mobile;
                }
            }
        },
        data() {
            return {
                needToValidate: true,
                onSend: false,
                note: '',
                search: '',
                arrowCounter: -1,
                enterPressed: false,
                isAsync: false,
                isOpen: false,
                isLoading: false,
                results: [],
                manualValidate: false,
                status: [
                    {item: true, name: "Is Patient a Minor?"},
                ],
                newBeginning: true,
                mobileRequired: false,
                flagForNames: true,
                tariff: null,
                nameError: false,
                zeroValue: false,
                emailError: false,
                emailErrorPatient: false,
                pharmaNameError: false,
                pharmaMobileError: false,
                selectEmailOrMobile: false,
                selectEmailOrMobilePatient: false,
                mobileError: false,
                mobileErrorPharma: false,
                pharmacist: {},
                sharedUrl: "",
                sharedUrlWithDetails: "",
                data: jsondata,
                selectedDetails: [],
                selectedDetailsPharmacist: [],
                signature: '',
                selectedPatient: null,
                selectedPharmacist: null,
                imagePrescription: false,
                submitted: false,
                lang: this.$lang.script,
                fileList: [],
                models: {
                    patientName: "",
                    mobileNumber: "",
                    emailId: "",
                    idNumber: "",
                    patientMinor: [],
                    parentName: "",
                    parentIDNumber: "",
                    icdCode: "",
                    medicineRequired: "",
                    specialInstructions: "",
                    dob: "",
                    gender: "",
                    bloodGroup: "",
                    address: "",
                    appointmentId: "",
                    formsManagementId:""
                },
                modelsPharmacist: {
                    name: "",
                    number: "",
                    emailId: "",
                },
                patientList: [],
                prescriptionList: [],
                icdCodeList: [],
                pharmacistList: [],
                patientDetails: [],
                pharmacistDetails: [],
                datePickerOptions: {
                    disabledDate(date) {
                        return date > new Date()
                    }
                },
                gender: [{value: "Male"}, {value: "Female"}, {value: "Other"}],
                bloodGroup: [
                    {value: "O+"},
                    {value: "O-"},
                    {value: "AB+"},
                    {value: "AB-"},
                    {value: "A+"},
                    {value: "A-"},
                    {value: "B+"},
                    {value: "B-"}
                ],
                smsNumber: "",
                smsContent: "",
                smsMessage: "",
            };
        },
        mounted() {
            let self = this;
            this.listenForNameBlur();
            this.listenForModalClose();
            this.$store.dispatch('getSignature').then(response => {
                if (response.data) {
                    self.signature = response.data.signature;
                    self.signature = response.data.signature;
                }
            });
            this.getPatientList();
            this.getPharmacistList();
            this.getPrescriptions();
            this.getICDcodes();
            this.tariff = this.login.myScriptPrice;
        },
        methods: {
            listenForNameBlur() {
                $("#patientName input").blur(function () {
                    this.needToValidate = true;
                });
            },
            openNoteModal() {
                this.$refs.send_note.show();
            },
            sendNote() {
                let self = this;
                self.onSend = true;
                let params = {
                    "note": this.note,
                    "formsManagementId": this.models.formsManagementId
                };
                this.$store.dispatch('sendNoteToNurse', params).then(value => {
                    self.$refs.send_note.hide();
                    self.onSend = false;
                    if (value.message) {
                        self.$alert(value.message, '', {
                            confirmButtonText: 'OK',
                            callback: action => {
                                self.$bvModal.show('modal-center');
                            }
                        });
                    }
                })
            },
            setResult(result) {
                this.search = result.prescription;
                this.isOpen = false;
            },
            onChange() {
                if (this.search.length) {
                    $('#autocomplete-results').show()
                } else {
                    this.results = [];
                    $('#autocomplete-results').hide()
                }
                if (this.isAsync) {
                    this.isLoading = true;
                } else {
                    this.filterResults();
                    this.isOpen = true;
                }
            },
            filterResults() {
                if (this.search.length > 2) {
                    this.results = this.prescriptionList.filter((item) => {
                        return item.prescription.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
                    });
                    !!this.results.length ? $('#autocomplete-results').show() : $('#autocomplete-results').hide();
                } else {
                    this.isOpen = false;
                }
            },
            onArrowDown() {
                if (this.arrowCounter < this.results.length) {
                    this.arrowCounter = this.arrowCounter + 1;
                }
            },
            onArrowUp() {
                if (this.arrowCounter > 0) {
                    this.arrowCounter = this.arrowCounter - 1;
                }
            },
            onEnter() {
                this.enterPressed = true;
//                this.search = this.results[this.arrowCounter] ? this.results[this.arrowCounter].prescription : '';
                this.search = this.results[this.arrowCounter] ? this.results[this.arrowCounter].prescription : this.search;
                this.isOpen = false;
                this.arrowCounter = -1;
            },
            getPrescriptions() {
                this.$store.dispatch('prescriptionSuggestions').then(response => {
                    if (response.status == 200) {
                        this.prescriptionList = response.data;
                    }
                })
            },
            getICDcodes() {
                this.$store.dispatch('icd10Codes').then(response => {
                    if (response.status == 200) {
                        this.icdCodeList = response.data.data;
                    }
                })
            },
            prescriptionBlurred() {
                this.manualValidate = false;
            },
            sendSms() {
                let self = this;
                let data = {};
                data = {
                    "message": this.smsContent,
                    "mobile": this.smsNumber,
                };
                this.$store.dispatch('shareScriptViaSMS', data).then(value => {
                    if (value.data) {
                        self.closeSmsModal();
                        self.$router.push({name: 'home'});
                    }
                });
            },
            openSmsModal() {
                if (this.models.mobileNumber) {
                    this.smsNumber = this.models.mobileNumber;
                }
                this.$bvModal.show('modal-center1');
            },
            closeSmsModal() {
                this.$alert(this.lang.label.smsSent, '', {
                    confirmButtonText: 'OK',
                    callback: action => {
                        this.$bvModal.hide('modal-center1');
                    }
                });
            },
            listenForModalClose() {
                let _this = this;
                this.$root.$on('bv::modal::hide', (bvModalEvent, modalId) => {
                    if (this.$route.name == 'create-electronic-script' || this.$route.name == 'create-script') {
                        let smsModal = $(_this.$refs['send_sms'])[0];
                        if (smsModal && smsModal.isHidden) {
                            _this.smsNumber = '';
                        }
                        if (modalId == 'modal-center2') {
                            this.$bvModal.show('modal-center');
                        }
                        if (modalId != 'modal-center') {
                            if (Object.keys(_this.patientInfo).length) {
                                if (_this.models.groupRequestId != null) {
                                    let noteModal = $(_this.$refs['send_note'])[0];
                                    if (noteModal && noteModal.isHidden) {
                                        _this.$router.push({name: 'group-request-list'});
                                    }
                                } else {
                                    _this.$router.push({name: 'script-requests'});
                                }
                            }
                        } else {
                            _this.clearAll();
                        }
                    }
                })
            },
            getPatientList() {
                this.$store.dispatch('getPatientDetails').then(response => {
                    this.patientDetails = response.data;
                    if (response.data) {
                        response.data.forEach((object) => {
                            this.patientList.push({name: object.name, mobile: object.mobile, id: object.id});
                        });
                        console.log(this.patientInfo)
                        if (Object.keys(this.patientInfo).length) {
                            this.models.patientName = this.patientInfo.name;
                            this.models.mobileNumber = this.patientInfo.mobile;
                            this.models.emailId = this.patientInfo.email;
                            this.models.idNumber = this.patientInfo.idNumber;
                            this.models.dob = this.patientInfo.dob;
                            // old
                            this.models.formsManagementId=this.patientInfo.formsManagementId;
                            //this.models.groupRequestId = this.patientInfo.groupRequestId != null ? this.patientInfo.groupRequestId : 0;
                            this.models.groupRequestId = this.patientInfo.formsManagementId!==null?this.patientInfo.formsManagementId:'';
                            this.models.icdCode = this.patientInfo.icdCode ? this.patientInfo.icdCode : '';
                            if (this.patientInfo.gender) {
                                this.models.gender = this.patientInfo.gender == 1 ? "Male" : (this.patientInfo.gender == 2 ? "Female" : "Other");
                            }
                            this.models.bloodGroup = this.patientInfo.bloodGroup;
                            this.models.address = this.patientInfo.address;
                            if (this.patientInfo.isMinor) {
                                this.models.patientMinor.push(this.status[0].item);
                            }
                            this.models.name = this.patientInfo.name;
                            this.models.parentName = this.patientInfo.parentName;
                            this.models.parentIDNumber = this.patientInfo.idNumberParent;
                            this.models.medicineRequired = this.patientInfo.medicine ? this.patientInfo.medicine : this.patientInfo.medication;
                            this.models.specialInstructions = this.patientInfo.specialInstructions;
                            this.$refs.patientName.inputValue = this.patientInfo.name;
                            this.models.patientId = this.patientInfo.patientId;
                            this.$refs.pharmacistName.inputValue = this.patientInfo.pharmacyName;
                            if (this.patientInfo.pharmacyName != null) {
                                this.modelsPharmacist.name = this.patientInfo.pharmacyName;
                                this.modelsPharmacist.number = this.patientInfo.pharmacistMobile?this.patientInfo.pharmacistMobile:"";
                                this.modelsPharmacist.emailId = this.patientInfo.pharmacyEmail;
                            }
                            this.models.appointmentId = this.patientInfo.appointmentId;
                        }
                    }
                });
            },
            getPharmacistList() {
                let info = {
                    "pageNo": 0,
                    "search": ""
                };
                this.$store.dispatch('getPharmacistDetails', info).then(response => {
                    this.pharmacistDetails = response.data;
                    if (response.data) {
                        response.data.forEach((object, index) => {
                            this.pharmacistList.push({name: object.name, location: object.location, mobile: object.mobile, id: object.id});
                        });
                    }
                });
            },
            isNumber(type, evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if (type == 1) {
                    if (this.models.mobileNumber.length >= 10) {
                        evt.preventDefault();
                    }
                }
                if (type == 2) {
                    if (this.modelsPharmacist.number.length >= 10) {
                        evt.preventDefault();
                    }
                }
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            createScript(e) {
                if (this.$refs.prescription && !this.$refs.prescription.value) {
                    this.manualValidate = false;
                    e.preventDefault();
                    this.$refs['prescription'].focus();
                    this.$refs['prescription'].blur();
                }
                if (parseInt(this.tariff) < 0) {
                    this.zeroValue = true;
                } else {
                    this.zeroValue = false;
                }
                if (!this.models.patientName) {
                    window.scrollTo(0, 0);
                    this.nameError = true;
                }
            },
            sendEmail() {
                this.$bvModal.hide('modal-center');
                this.$router.push({name: 'home'});
            },
            onCopy: function (e) {
                this.notifyVue('success');

            },
            onError: function (e) {
                this.notifyVueError('error');
            },
            notifyVue(type = 'success') {
                this.$notify({
                    message: 'Link copied Successfully!!',
                    timeout: 5000,
                    type
                });
                if (type = 'success') {
                    this.$router.push({name: 'home'});
            }
            },
            notifyVueError(type = 'error') {
                this.$notify({
                    message: 'Failed to copy link',
                    timeout: 5000,
                    type
                });
            },
            copyToClipBoard1() {
                let copyText = document.getElementById("input-url");
                copyText.select();
                copyText.setSelectionRange(0, 99999)
                document.execCommand("copy");
                this.$bvModal.hide('modal-center');
            },
            getImgUrl(pic) {
                return require("../assets/styles/img/" + pic);
            },
            getValidationStatePrescription( { dirty, validated, valid = null }) {
                if (this.manualValidate)
                    return null;
                return dirty || validated ? valid : null;
            },
            getValidationState( { dirty, validated, valid = null }) {
                if (this.mobileError) {
                    return false;
                } else if (this.mobileErrorPharma) {
                    return false;
                } else {
                    return dirty || validated ? valid : null;
            }
            },
            onSubmit() {
                if (!this.mobileError && !this.mobileErrorPharma) {
                    if (!this.$refs.patientName.inputValue) {
                        this.nameError = true;
                        window.scrollTo(0, 0);
                        return true;
                    }
                    if (this.zeroValue) {
                        return true;
                    }
                    let emailPatient = this.models.emailId;
                    let namePatient = this.models.patientName;
                    let numberPatient = this.models.mobileNumber;
                    let email = this.modelsPharmacist.emailId;
                    let name = this.modelsPharmacist.name;
                    let number = this.modelsPharmacist.number;
                    if ((this.nameError && this.emailErrorPatient && this.mobileError) || (numberPatient && !namePatient) || ((namePatient && !numberPatient) && (namePatient && !emailPatient)) || (!namePatient && emailPatient)) {
                        window.scrollTo(0, 0);
                        this.selectEmailOrMobilePatient = true;
                        return true;
                    } else {
                        this.selectEmailOrMobilePatient = false;
                    }
                    if ((this.pharmaNameError && this.emailError && this.pharmaMobileError) || (number && !name) || ((name && !number) && (name && !email)) || (!name && email)) {
                        this.selectEmailOrMobile = true;
                        return true;
                    } else {
                        this.selectEmailOrMobile = false;
                    }
                    let self = this;
                    this.submitted = true;
                    let date_of_birth = '';
                    if (this.models.dob) {
                        date_of_birth = moment(this.models.dob).format("YYYY-MM-DD");
                    }
                    let gender = '';
                    gender = this.models.gender;
                    if (gender) {
                        gender = gender == "Male" ? 1 : (gender == "Female" ? 2 : 3);
                    } else {
                        gender = '';
                    }
                    let scriptType = 1;
                    let scriptPrice = this.tariff || this.tariff == 0 ? parseInt(this.tariff) : '';
                    let data = {};
                    data = {
                        "scriptType": scriptType,
                        "patientId": this.selectedDetails[0] && this.selectedDetails[0].id ? this.selectedDetails[0].id : (Object.keys(this.patientInfo).length) && this.patientInfo.patientId ? this.patientInfo.patientId : 0,
                        "name": this.models.patientName,
                        "email": this.models.emailId,
                        "mobile": this.models.mobileNumber,
                        "gender": gender,
                        "bloodGroup": this.models.bloodGroup,
                        "dob": date_of_birth,
                        "address": this.models.address,
                        "icdCode": this.models.icdCode,
                        "pharmacistName": this.modelsPharmacist.name,
                        "pharmacistEmail": this.modelsPharmacist.emailId,
                        "pharmacistMobile": this.modelsPharmacist.number,
                        "scriptPrice": scriptPrice,
                        "prescription": this.search,
                        "groupRequestId": this.models.groupRequestId,
                        "formsManagementId":this.models.formsManagementId,
                        "pharmacistId": this.selectedDetailsPharmacist[0] && this.selectedDetailsPharmacist[0].id ? this.selectedDetailsPharmacist[0].id : (Object.keys(this.patientInfo).length) && this.patientInfo.pharmacistId ? this.patientInfo.pharmacistId : 0,
                    };
                    if (Object.keys(this.patientInfo).length) {
                        if (this.models.idNumber) {
                            data.idNumber = this.models.idNumber;
                        }
                        data.isMinor = this.models.patientMinor.length ? 1 : 0;
                        if (this.models.parentName) {
                            data.parentName = this.models.parentName;
                        }
                        if (this.models.parentIDNumber) {
                            data.idNumberParent = this.models.parentIDNumber;
                        }
                        if (this.models.medicineRequired) {
                            data.medicine = this.models.medicineRequired;
                        }
                        if (this.models.specialInstructions) {
                            data.specialInstructions = this.models.specialInstructions;
                        }
                    }
                    if (this.models.appointmentId) {
                        data.appointmentId = this.models.appointmentId;
                    }
                    this.$store.dispatch('createScript', data).then(value => {

                        this.getPrescriptions();
                        this.getICDcodes();
                        if (value.data) {
                            self.sharedUrl = value.data.sharedURL;
                            self.sharedUrlWithDetails = self.scriptDetails();
                            self.smsContent = self.scriptSmsDetails();
                            self.open();
                        }
                    });
                } else {
                    if (this.mobileError) {
                        $("#mobileError").focus();
                    } else {
                        $("#mobileErrorPharma").focus();
                    }
                }
            },
            wantToSendNote() {
                let self = this;
                this.$swal.fire({
                    title: '',
                    text: self.lang.label.sendNote,
                    type: '',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'YES',
                    cancelButtonText: 'NO',
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.value) {
                        self.openNoteModal();
                    } else {
                        self.$bvModal.show('modal-center');
                    }
                })
            },
            open() {
                let self = this;
                this.$alert(this.lang.label.eScriptCreated, '', {
                    confirmButtonText: 'OK',
                    callback: action => {
                        if (self.fromGroupRequests) {
                            self.$store.commit('setFromGroupRequests', false);
                            self.wantToSendNote();
                        } else {
                            self.$bvModal.show('modal-center');
                        }
                    }
                });
            },
            scriptSmsDetails() {
                let body;
                body = 'Dear ' + this.models.patientName + ',' + ' You submitted a request for a script / form to ' + this.login.practiceName + '. If you requested the document, please click this link ' + this.sharedUrl + '  to download the document.';
                return body;
            },
            scriptDetails() {
                let subject = 'mailto:' + this.models.emailId + '?subject=Payscript – Script / Form from ' + this.login.practiceName + ' &body=';
                let body;
                if (this.tariff == 0) {
                    body = 'Dear ' + this.models.patientName + ',' + '%0D%0A%0D%0A' + 'You submitted a request for a script / form to ' + this.login.practiceName + '. If you requested the document, please ' + 'OPEN ' + this.sharedUrl + ' to access the document.' + '%0D%0A%0D%0A' + 'Thank you, %0D%0A' + this.login.practiceName;
                } else {
                    body = 'Dear ' + this.models.patientName + ',' + '%0D%0A%0D%0A' + 'You submitted a request for a script / form to ' + this.login.practiceName + '. If you requested the document, please ' + 'OPEN ' + this.sharedUrl + ' to pay and access the document.' + '%0D%0A%0D%0A' + 'Thank you, %0D%0A' + this.login.practiceName;
                }
                return subject + body;
                // return this.login.email+'?subject=Pay Script::Script Generated&amp;body=Dear '+this.models.patientName+', you submitted a request for a script / form to '+this.login.name+'. If you requested the document, please click this link '+'"'+ this.sharedUrl +'"'+' to make payment and download the document. Thank you, '+this.login.name;
            },
            clearAll() {
                let self = this;
                this.$store.commit('setPatientInfo', {});
                this.manualValidate = true;
                this.arrowCounter = -1;
                this.enterPressed = false;
                this.isAsync = false;
                this.isOpen = false;
                this.isLoading = false;
                this.results = [];
                this.models.mobileNumber = "";
                this.models.parentName = "";
                this.models.parentIDNumber = "";
                this.models.medicineRequired = "";
                this.models.idNumber = "";
                this.models.specialInstructions = "";
                this.models.patientMinor = [];
                this.models.icdCode = "";
                this.models.emailId = "";
                this.models.dob = "";
                this.models.gender = "";
                this.models.bloodGroup = "";
                this.models.address = "";
                this.newBeginning = true;
                this.modelsPharmacist.number = "";
                this.modelsPharmacist.emailId = "";
                this.models.groupRequestId = 0;
                this.flagForNames = false;
                this.models.patientName = '';
                this.modelsPharmacist.name = '';
                if (this.$refs.patientName)
                    this.$refs.patientName.inputValue = "";
                if (this.$refs.pharmacistName)
                    this.$refs.pharmacistName.inputValue = "";
                if (this.$refs.icd10Code)
                    this.$refs.icd10Code.inputValue = "";
                this.modelsPharmacist.name = "";
                this.search = "";
                if (this.$refs.observer) {
                    this.needToValidate = true;
                    this.$refs.observer.reset();
                } else {
                    this.needToValidate = false;
                }
                this.selectedDetails = [];
                this.patientList = [];
                this.pharmacistList = [];
                this.selectedDetailsPharmacist = [];
                this.selectedPatient = null;
                this.selectedPharmacist = null;
                this.errorClear();
                this.getPatientList();
                this.getPharmacistList();
            },
            errorClear() {
                this.mobileError = false;
                this.mobileErrorPharma = false;
                this.pharmaMobileError = false;
                this.emailErrorPatient = false;
                this.emailError = false;
                this.mobileError = false;
                this.pharmaNameError = false;
                this.selectEmailOrMobile = false;
                this.selectEmailOrMobilePatient = false;
            },
            handleRemove(file, fileList) {
            },
            handlePreview(file) {
            },
            deletePrescription(prescription){
                let self=this;
                let data={
                    "scriptId":prescription.scriptIds
                }
                self.$store.dispatch("deletePrescription",data).then((response)=>{
                    if(response.data.message && response.data.message=='Remove script successfully.'){
                        self.getPrescriptions();
                        self.search=''
                    }
                })
            }
        },
        destroyed() {
            this.$store.commit('setPatientInfo', {});
        }
    };
</script>
<style>
    .autocomplete {
        position: relative;
    }

    .autocomplete-results {
        padding: 0;
        margin: 0;
        border: 1px solid #eeeeee;
        height: 120px;
        overflow: auto;
        width: 100%;
    }

    .autocomplete-result {
        list-style: none;
        text-align: left;
        padding: 4px 2px;
        cursor: pointer;
    }
    .autocomplete-result .btn{
        min-height: auto;
        color: #f00;
    }

    .autocomplete-result.is-active,
    .autocomplete-result:hover {
        background-color: #34388D!important;
        color: #ffffff !important;
    }
    .autocomplete-result.is-active .btn,
    .autocomplete-result:hover .btn {
        color: #ffffff !important;
    }
</style>
